import React from "react";

// Mui Styles
import { StyledPaper } from "@/styles/mui/globalStyles";
import {
  TableListTheme,
  employeeShoppingTabTheme,
} from "@/styles/mui/tableListTheme";
import AddBoxIcon from "@mui/icons-material/AddBox";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import ScheduleIcon from "@mui/icons-material/Schedule";
import LoadingButton from "@mui/lab/LoadingButton";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import Grid from "@mui/material/Grid2";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import InputLabel from "@mui/material/InputLabel";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Stack from "@mui/material/Stack";
import { ThemeProvider } from "@mui/material/styles";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import TextField from "@mui/material/TextField";
import { darken, lighten, styled } from "@mui/system";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";

// CSS
import "@/styles/page/systemSettingProductPage.css";

// Navigate
import { useNavigate } from "react-router-dom";

// Components
import DataTable from "@/components/dataTable";
import EmployeeBenefitDialog from "@/components/Dialog/employeeBenefitDialog";
import Layout from "@/components/layout";
import Title from "@/components/title";
import {
  EmployeeBenefitTable1Column,
  EmployeeBenefitTable2Column,
} from "@/config/tableColumnConfig";

// Mui Icon
import DownloadIcon from "@mui/icons-material/Download";
import DriveFolderUploadIcon from "@mui/icons-material/DriveFolderUpload";

import { getBrandTypes } from "@/fetch/fetchType";
import extractEmployeeDiscount from "@/lib/extractEmployeeDiscount";
import Tooltip from "@mui/material/Tooltip";
import {
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarFilterButton,
} from "@mui/x-data-grid";
import {
  createEmployeeDiscount,
  createEmployeeDiscountByOne,
  createEmployeeDiscountMonthly,
  fetchEmployeeDiscountTemplateFromPast,
  getAllEmployeeDiscountProducts,
  getEmployeeDiscountMonthly,
  getEmployeeDiscountMonthlyAvailable,
  getEmployeeDiscountMonthlyListAvailable,
} from "../fetch/fetchEmployeePurchase";

//moment
import moment from "moment";

// Fetch
import {
  fetchEmployeeDiscount,
  fetchEmployeeDiscountTemplate,
} from "@/fetch/fetchEmployeePurchase";

// Moment
import Moment from "moment";
import { extendMoment } from "moment-range";
import "moment/locale/zh-hk";

import _ from "lodash";

const EmployeeBenefitPage = (props) => {
  const { open, setOpen } = props;
  const moment = extendMoment(Moment);

  // Navigate
  const navigate = useNavigate();

  moment.updateLocale("zh-hk", {
    weekdaysShort: ["日", "一", "二", "三", "四", "五", "六"],
  });

  // States
  const [dataTableLoading, setDataTableLoading] = React.useState(true);
  const [brand, setBrand] = React.useState([]);
  const [discountData1, setDiscountData1] = React.useState([]);
  const [discountData2, setDiscountData2] = React.useState([]);
  const [snackSeverity, setSnackSeverity] = React.useState("success");
  const [snackMessage, setSnackMessage] = React.useState("");
  const [snackOpen, setSnackOpen] = React.useState(false);
  const [isLoading, setLoading] = React.useState(false);
  const [openDialog, setOpenDialog] = React.useState(false);
  const [mode, setMode] = React.useState("create");
  const [onChangeData, setOnChangeData] = React.useState({
    month: moment().format("YYYY-MM-DD"),
  });
  const [availableMonth, setAvailableMonth] = React.useState([]);
  const [availableProdut, setAvaliableProduct] = React.useState([]);
  const [availablePastMonthList, setAvailableMonthList] = React.useState([]);
  const [dialogValue1, setDialogValue1] = React.useState({
    isActive: "請選擇",
    discountMonth: "請選擇",
  });
  const dialogValue2InitValue = {
    discountMonth: "請選擇",
    cutOffDate: moment().endOf("month"),
  };
  const [dialogValue2, setDialogValue2] = React.useState(dialogValue2InitValue);
  const [isErrorTab2, setIsErrorTab2] = React.useState({});
  const [isErrorTab1, setIsErrorTab1] = React.useState({});
  const selectRange = Array.from({ length: 13 }, (_, index) =>
    moment().startOf("year").add(index, "month").format("YYYY-MM")
  );

  const onOpen = () => {
    setOpenDialog((prev) => !prev);
  };

  const onCloseTab2 = () => {
    setDialogValue2(dialogValue2InitValue);
    setIsErrorTab2({});
    setOpenDialog((prev) => !prev);
    setMode("create");
  };

  const onCloseTab1 = () => {
    setDialogValue1({});
    setIsErrorTab1({});
    setOpenDialog((prev) => !prev);
    setMode("create");
  };

  const [tabValue, setTabValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  // Fetch
  const fetchAll = async () => {
    try {
      setLoading(true);
      setDataTableLoading(true);

      const gedmaData = await getEmployeeDiscountMonthlyAvailable(
        moment().format("YYYY-MM-DD")
      );
      const gedmlaData = await getEmployeeDiscountMonthlyListAvailable(
        moment().format("YYYY-MM-DD")
      );

      const { data: brand } = await getBrandTypes();
      const gadpData = await getAllEmployeeDiscountProducts();

      const fedData = await fetchEmployeeDiscount(
        onChangeData.month,
        onChangeData.month
      );

      const gedmData = await getEmployeeDiscountMonthly(
        onChangeData.month,
        onChangeData.month
      );
      setBrand(brand);
      setAvailableMonth(gedmaData.data);
      setAvailableMonthList(gedmlaData.data);
      setAvaliableProduct(gadpData.data);
      setDiscountData1(fedData.data);
      setDiscountData2(gedmData.data);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
      setDataTableLoading(false);
    }
  };

  const createDiscountMonthly = async () => {
    const isErrorTab2 = {
      discountMonth:
        dialogValue2.discountMonth && dialogValue2.discountMonth !== "請選擇"
          ? ""
          : "不能為空值",
      cutOffDate: moment(dialogValue2.cutOffDate).isAfter(moment())
        ? ""
        : "必須要遲於今日",
    };

    if (Object.values(isErrorTab2).some((item) => item)) {
      setIsErrorTab2(isErrorTab2);
      return false;
    }

    await createEmployeeDiscountMonthly({
      ...dialogValue2,
      cutOffDate: moment(dialogValue2.cutOffDate).format("YYYY-MM-DD"),
      cutOffTime: moment(dialogValue2.cutOffTime).format("HH:mm"),
    }).then((data) => {
      if (data.results && data.data) {
        setSnackMessage(`${mode === "modify" ? "已修改" : "已新增"}`);
        setSnackSeverity("success");
        setSnackOpen(true);
        onCloseTab2();
        fetchAll();
      }
    });
  };

  const createDiscount = async () => {
    const isErrorTab1 = {
      productMasterId: !_.isEmpty(dialogValue1.productMasterId)
        ? ""
        : "不能為空值",
      discountMonth:
        dialogValue1.discountMonth && dialogValue1.discountMonth !== "請選擇"
          ? ""
          : "不能為空值",
      discountPrice: dialogValue1.discountPrice ? "" : "不能為空值",
      promoterDiscountPrice: dialogValue1.promoterDiscountPrice
        ? ""
        : "不能為空值",
      isActive: typeof dialogValue1.isActive === "boolean" ? "" : "不能為空值",
    };

    if (Object.values(isErrorTab1).some((item) => item)) {
      setIsErrorTab1(isErrorTab1);
      return false;
    }
    const newData = {
      ...dialogValue1,
      productMasterId: dialogValue1.productMasterId.id,
      isActive: dialogValue1.isActive,
    };

    await createEmployeeDiscountByOne(newData).then((data) => {
      if (data.results && data.data.length > 0) {
        setSnackMessage(`${mode === "modify" ? "已修改" : "已新增"}`);
        setSnackSeverity("success");
        setSnackOpen(true);
        onCloseTab1();
        fetchAll();
      }
    });
  };

  // Browser Back
  const handleBeforeUnload = (e) => {
    e.preventDefault();
    const message =
      "Are you sure you want to leave? All provided data will be lost.";
    e.returnValue = message;
    return message;
  };

  const filterOptions = createFilterOptions({
    stringify: (option) => option.product_name,
  });

  const tabOne = (
    <Box sx={{ p: 2 }}>
      <Grid container spacing={5} rowGap={5}>
        <Grid size={8}>
          <Autocomplete
            disabled={mode === "modify" ? true : false}
            groupBy={(option) => option.brand_types_name}
            filterOptions={filterOptions}
            value={dialogValue1.productMasterId}
            options={availableProdut}
            fullWidth
            getOptionLabel={(option) => option.product_name}
            isOptionEqualToValue={(option, value) => option?.id === value?.id}
            onChange={(_, value) => {
              setDialogValue1((prev) => ({
                ...prev,
                productMasterId: value,
              }));
            }}
            renderInput={(params) => (
              <TextField
                color="success"
                helperText={isErrorTab1.productMasterId}
                error={!!isErrorTab1.productMasterId}
                {...params}
                label="產品"
              />
            )}
            renderGroup={(params) => (
              <li key={params.key}>
                <GroupHeader>{params.group}</GroupHeader>
                <GroupItems>{params.children}</GroupItems>
              </li>
            )}
          />
        </Grid>
        <Grid size={4}>
          <FormControl fullWidth>
            <InputLabel
              color="success"
              error={!!isErrorTab1.discountMonth}
              id="demo-simple-select-label"
            >
              折扣月份
            </InputLabel>
            <Select
              disabled={mode === "modify" ? true : false}
              color="success"
              error={!!isErrorTab1.discountMonth}
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={dialogValue1.discountMonth}
              label="折扣月份"
              onChange={(event) => {
                setDialogValue1((prev) => ({
                  ...prev,
                  discountMonth: event.target.value,
                }));
              }}
            >
              <MenuItem disabled value={"請選擇"}>
                請選擇
              </MenuItem>
              {availableMonth.map((item, index) => (
                <MenuItem
                  disable={moment(item.discount_month, "YYYY-MM").isBefore(
                    moment(),
                    "month"
                  )}
                  key={index}
                  value={item.id}
                >
                  {item.discount_month}
                </MenuItem>
              ))}
            </Select>
            {isErrorTab1.discountMonth && (
              <FormHelperText error={!!isErrorTab1.discountMonth}>
                請選擇一項
              </FormHelperText>
            )}
          </FormControl>
        </Grid>
        <Grid size={2}>
          <TextField
            color="success"
            helperText={isErrorTab1.discountPrice}
            error={!!isErrorTab1.discountPrice}
            InputProps={{ startAdornment: "$" }}
            inputProps={{ style: { textAlign: "center" } }}
            value={dialogValue1.discountPrice}
            fullWidth
            id="standard-basic"
            label="折扣價(BackOffice)"
            variant="standard"
            margin="dense"
            onChange={(event) => {
              setDialogValue1((prev) => ({
                ...prev,
                discountPrice: floatFixed2(event.target.value),
              }));
            }}
          />
        </Grid>
        <Grid size={2}>
          <TextField
            color="success"
            helperText={isErrorTab1.promoterDiscountPrice}
            error={!!isErrorTab1.promoterDiscountPrice}
            InputProps={{ startAdornment: "$" }}
            inputProps={{ style: { textAlign: "center" } }}
            value={dialogValue1.promoterDiscountPrice}
            fullWidth
            id="standard-basic"
            label="折扣價(Promoter)"
            variant="standard"
            margin="dense"
            onChange={(event) => {
              setDialogValue1((prev) => ({
                ...prev,
                promoterDiscountPrice: floatFixed2(event.target.value),
              }));
            }}
          />
        </Grid>
        <Grid size={2}>
          <TextField
            color="success"
            helperText={isErrorTab1.itemQuota}
            error={!!isErrorTab1.itemQuota}
            fullWidth
            value={dialogValue1.itemQuota}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">最多</InputAdornment>
              ),
              endAdornment: "件",
            }}
            inputProps={{ style: { textAlign: "center" } }}
            id="standard-basic"
            label="限額"
            variant="standard"
            margin="dense"
            onChange={(event) => {
              setDialogValue1((prev) => ({
                ...prev,
                itemQuota: isNaN(event.target.value)
                  ? ""
                  : Math.abs(event.target.value),
              }));
            }}
          />
        </Grid>
        <Grid size={3}>
          <TextField
            color="success"
            fullWidth
            InputProps={{ startAdornment: " " }}
            value={dialogValue1.remark}
            type="text"
            id="standard-basic"
            label="備註"
            variant="standard"
            margin="dense"
            onChange={(event) => {
              setDialogValue1((prev) => ({
                ...prev,
                remark: event.target.value,
              }));
            }}
          />
        </Grid>
        <Grid size={3}>
          <FormControl fullWidth>
            <InputLabel
              color="success"
              error={!!isErrorTab1.isActive}
              id="demo-simple-select-label"
            >
              狀態
            </InputLabel>
            <Select
              color="success"
              error={!!isErrorTab1.isActive}
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={dialogValue1.isActive}
              label="Active"
              onChange={(event) => {
                setDialogValue1((prev) => ({
                  ...prev,
                  isActive: event.target.value,
                }));
              }}
            >
              <MenuItem disabled value={"請選擇"}>
                請選擇
              </MenuItem>
              <MenuItem value={true}>開啟</MenuItem>
              <MenuItem value={false}>關閉</MenuItem>
            </Select>
            {isErrorTab1.isActive && (
              <FormHelperText error={!!isErrorTab1.isActive}>
                請選擇一項
              </FormHelperText>
            )}
          </FormControl>
        </Grid>
      </Grid>
    </Box>
  );

  const handleCutOffTime = () => {
    const remarkText =
      document.querySelector(".remark_textArea")?.firstElementChild
        .nextElementSibling.firstElementChild;

    const newText = "\u23F0";

    const start = remarkText.selectionStart;
    const textBeforeInsert = remarkText.value.substring(
      0,
      remarkText.selectionStart
    );
    const textAfterInsert = remarkText.value.substring(
      remarkText.selectionEnd,
      remarkText.value.length
    );
    remarkText.value = textBeforeInsert + newText + textAfterInsert;
    remarkText.selectionStart = remarkText.selectionEnd =
      start + newText.length;
    remarkText.focus();
    setDialogValue2((prev) => ({
      ...prev,
      msg: remarkText.value,
    }));
  };

  const handleCutOffDate = () => {
    const remarkText =
      document.querySelector(".remark_textArea")?.firstElementChild
        .nextElementSibling.firstElementChild;

    const newText = "\u{1F5D3}";

    const start = remarkText.selectionStart;

    const textBeforeInsert = remarkText.value.substring(
      0,
      remarkText.selectionStart
    );

    const textAfterInsert = remarkText.value.substring(
      remarkText.selectionEnd,
      remarkText.value.length
    );
    remarkText.value = textBeforeInsert + newText + textAfterInsert;

    remarkText.selectionStart = remarkText.selectionEnd =
      start + newText.length;
    remarkText.focus();

    setDialogValue2((prev) => ({
      ...prev,
      msg: remarkText.value,
    }));
  };

  const tabTwo = (
    <Box sx={{ p: 5 }}>
      <Grid container spacing={2} rowGap={1}>
        <Grid container>
          <Grid size={12}>
            <Stack direction={"row"} justifyContent={"flex-end"}>
              <Tooltip title="截止時間">
                <IconButton
                  onClick={handleCutOffTime}
                  color="secondary"
                  aria-label="add an alarm"
                >
                  <ScheduleIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="截止日期">
                <IconButton
                  onClick={handleCutOffDate}
                  color="info"
                  aria-label="add an alarm"
                >
                  <EventAvailableIcon />
                </IconButton>
              </Tooltip>
            </Stack>
          </Grid>
        </Grid>
        <Grid size={8}>
          <FormControl fullWidth>
            <InputLabel
              error={!!isErrorTab2.discountMonth}
              color="success"
              id="demo-simple-select-label"
            >
              折扣月份
            </InputLabel>
            <Select
              disabled={mode === "modify" ? true : false}
              error={!!isErrorTab2.discountMonth}
              color="success"
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={dialogValue2.discountMonth}
              label="折扣月份"
              onChange={(event) => {
                setDialogValue2((prev) => ({
                  ...prev,
                  discountMonth: event.target.value,
                  cutOffDate: moment(event.target.value).endOf("month"),
                }));
              }}
            >
              <MenuItem disabled value="請選擇">
                請選擇
              </MenuItem>
              {selectRange.map((item, index) => (
                <MenuItem
                  disabled={moment(item, "YYYY-MM").isBefore(moment(), "month")}
                  key={index}
                  value={item}
                >
                  {item}
                </MenuItem>
              ))}
            </Select>
            {isErrorTab2.discountMonth && (
              <FormHelperText error={!!isErrorTab2.discountMonth}>
                請選擇一項
              </FormHelperText>
            )}
          </FormControl>
        </Grid>
        <Grid size={4}>
          <TextField
            error={!!isErrorTab2.quota}
            helperText={isErrorTab2.quota}
            color="success"
            value={dialogValue2.quota}
            margin="dense"
            InputProps={{ startAdornment: "$" }}
            inputProps={{ style: { textAlign: "center" } }}
            fullWidth
            id="standard-basic"
            label="限額"
            variant="standard"
            onChange={(event) => {
              setDialogValue2((prev) => ({
                ...prev,
                quota: floatFixed2(event.target.value),
              }));
            }}
          />
        </Grid>
        <Grid size={6}>
          <FormControl fullWidth>
            <DateTimePicker
              disablePast
              minDate={moment(dialogValue2.discountMonth)
                .add(1, "day")
                .format("YYYY-MM-DD")}
              inputFormat="YYYY/MM/DD"
              maxDate={moment(dialogValue2.discountMonth)
                .endOf("month")
                .format("YYYY-MM-DD")}
              renderInput={(props) => (
                <TextField
                  error={!!isErrorTab2.cutOffDate}
                  color="success"
                  {...props}
                />
              )}
              views={["day"]}
              label="截數日期"
              value={dialogValue2.cutOffDate}
              onChange={(event) => {
                setDialogValue2((prev) => ({
                  ...prev,
                  cutOffDate: event,
                }));
              }}
            />
            {isErrorTab2.cutOffDate && (
              <FormHelperText error={!!isErrorTab2.cutOffDate}>
                {isErrorTab2.cutOffDate}
              </FormHelperText>
            )}
          </FormControl>
        </Grid>
        <Grid size={6}>
          <FormControl fullWidth>
            <TimePicker
              color="success"
              label="截數時間"
              ampm
              value={dialogValue2.cutOffTime}
              onChange={(event) => {
                console.log(event);
                setDialogValue2((prev) => ({
                  ...prev,
                  cutOffTime: event,
                }));
              }}
              renderInput={(params) => (
                <TextField color="success" {...params} />
              )}
            />
          </FormControl>
        </Grid>
        <Grid size={12}>
          <TextField
            className="remark_textArea"
            color="success"
            InputProps={{ startAdornment: " " }}
            rows={5}
            value={dialogValue2.msg}
            fullWidth
            multiline
            id="standard-basic"
            label="備註"
            variant="outlined"
            onChange={(event) => {
              setDialogValue2((prev) => ({
                ...prev,
                msg: event.target.value,
              }));
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );

  const dialogProps1 = {
    open: openDialog,
    onClose: onCloseTab1,
    onSubmit: createDiscount,
    layout: tabOne,
    size: "md",
    mode: mode,
    title: "產品設定",
  };
  const dialogProps2 = {
    open: openDialog,
    onSubmit: createDiscountMonthly,
    onClose: onCloseTab2,
    layout: tabTwo,
    size: "sm",
    mode: mode,
    title: "設定",
  };

  const tabArr = [
    {
      column: EmployeeBenefitTable1Column(brand),
      data: discountData1,
      func: (row) => setDialogValue1(row),
    },
    {
      column: EmployeeBenefitTable2Column,
      data: discountData2,
      func: (row) => setDialogValue2(row),
    },
  ];

  React.useEffect(() => {
    fetchAll();
    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Layout
      header="StaffManagePage"
      snackOpen={snackOpen}
      snackClose={() => setSnackOpen(false)}
      snackMessage={snackMessage}
      snackSeverity={snackSeverity}
      open={open}
      setOpen={setOpen}
    >
      <Title
        title={`員工購物設定`}
        history={() => navigate(-1)}
        children={
          <div>
            <UploadButton
              {...{ setSnackMessage, setSnackOpen, setSnackSeverity, fetchAll }}
            />
            <ButtonMenu date={availablePastMonthList} />
          </div>
        }
      />
      <EmployeeBenefitDialog
        {...{ ...(tabValue === 1 ? dialogProps2 : dialogProps1) }}
      />
      <StyledPaper page={"yes"}>
        <Box sx={{ m: 3, width: "100%" }}>
          <Stack
            direction={"row"}
            alignItems={"flex-start"}
            justifyContent={"space-between"}
            spacing={2}
          >
            <Stack>
              <FormControl>
                <DateTimePicker
                  inputFormat="MM/YYYY"
                  renderInput={(props) => (
                    <TextField
                      color="success"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderBottomRightRadius: 0,
                          borderBottomLeftRadius: 0,
                        },
                      }}
                      {...props}
                    />
                  )}
                  label="Month"
                  openTo="month"
                  views={["year", "month"]}
                  value={onChangeData.month}
                  onChange={(event) => {
                    setOnChangeData({
                      ...onChangeData,
                      month: moment(event._d).format("YYYY-MM-DD"),
                    });
                  }}
                />
              </FormControl>
              <FormControl>
                <LoadingButton
                  sx={{ borderTopLeftRadius: 0, borderTopRightRadius: 0 }}
                  onClick={fetchAll}
                  size="small"
                  loading={isLoading}
                  loadingIndicator="Loading…"
                  variant="contained"
                  color="success"
                >
                  搜尋
                </LoadingButton>
              </FormControl>
            </Stack>
            <Button
              sx={{
                color: "#ffb74d",
                borderColor: "#ffb74d",
              }}
              color="warning"
              variant="outlined"
              startIcon={<AddBoxIcon />}
              onClick={onOpen}
            >
              新增
            </Button>
          </Stack>
        </Box>
        <ThemeProvider theme={TableListTheme}>
          <Box sx={{ width: "100%" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <ThemeProvider theme={employeeShoppingTabTheme}>
                <Tabs
                  value={tabValue}
                  onChange={handleChange}
                  aria-label="basic tabs example"
                  centered
                >
                  <Tab label="產品設定" {...a11yProps(0)} />
                  <Tab label="設定" {...a11yProps(1)} />
                </Tabs>
              </ThemeProvider>
            </Box>
            {tabArr.map((item, index) => (
              <CustomTabPanel key={index} value={tabValue} index={index}>
                <Stack direction={"column"}>
                  <DataTable
                    loading={dataTableLoading}
                    // newEditingApi={true}
                    rows={item.data}
                    columns={item.column}
                    pageSize={100}
                    Toolbar={CustomToolbar}
                    onCellClick={(param) => {
                      const { row } = param;
                      let newValue = {};
                      if ("msg" in row) {
                        newValue = {
                          msg: row.msg,
                          quota: row.quota,
                          discountMonth: row.discount_month,
                          cutOffDate: row.cut_off_date,
                          cutOffTime: moment(row.cut_off_time, "HH:mm"),
                        };
                      } else {
                        newValue = {
                          productMasterId: availableProdut.find(
                            (item) => item.id === row.product_master_id
                          ),
                          discountMonth: row.employee_discount_monthly_id,
                          isActive: row.is_active,
                          itemQuota: row.item_quota,
                          discountPrice: row.product_discount_price,
                          promoterDiscountPrice:
                            row.promoter_product_discount_price,
                          remark: row.remark,
                        };
                      }
                      if (
                        moment(row.cut_off_date, "YYYY-MM-DD").isBefore(
                          moment(),
                          "day"
                        )
                      ) {
                        setSnackMessage("不能修改");
                        setSnackSeverity("error");
                        setSnackOpen(true);
                      } else {
                        item.func(newValue);
                        setMode("modify");
                        onOpen();
                      }
                    }}
                  />
                </Stack>
              </CustomTabPanel>
            ))}
          </Box>
        </ThemeProvider>
      </StyledPaper>
    </Layout>
  );
};

export default EmployeeBenefitPage;

function CustomToolbar() {
  return (
    <GridToolbarContainer>
      <GridToolbarColumnsButton />
      <GridToolbarFilterButton />
      <GridToolbarDensitySelector />
    </GridToolbarContainer>
  );
}

function ButtonMenu({ date }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const [timeValue, setTimeValue] = React.useState();

  const downLoadTemplate = async (month, isTemplate) => {
    try {
      const func = async (cb, arg) => {
        await cb(arg)
          .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute(
              "download",
              `員工購物產品設定(${Moment(month).format("YYYY-MM")}).xlsx`
            );
            document.body.appendChild(link);
            link.click();
          })
          .catch((err) => console.log("err", err));
      };

      func(
        !isTemplate
          ? fetchEmployeeDiscountTemplateFromPast
          : fetchEmployeeDiscountTemplate,
        month
      );
    } catch (err) {
      console.log(err.message);
    }
  };

  return (
    <>
      <IconButton
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
      >
        <DownloadIcon />
      </IconButton>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <Stack spacing={2}>
          <FormControl>
            <DateTimePicker
              inputFormat="MM/YYYY"
              renderInput={(props) => <TextField {...props} />}
              label="下載過去月份範本"
              openTo="month"
              views={["year", "month"]}
              shouldDisableMonth={(month) =>
                !date.includes(moment(month).format("YYYY-MM"))
              }
              onChange={(event) => {
                setTimeValue(event);
              }}
              onMonthChange={(event) => {
                downLoadTemplate(moment(event).format("YYYY-MM"), false);
                handleClose();
              }}
            />
          </FormControl>
          <Stack direction={"row"} justifyContent={"center"}>
            <Button
              variant="outlined"
              startIcon={<DownloadIcon />}
              onClick={() => {
                downLoadTemplate(moment().format("YYYY-MM"), true);
                handleClose();
              }}
            >
              下載新範本
            </Button>
          </Stack>
        </Stack>
      </Menu>
    </>
  );
}

function UploadButton({
  setSnackSeverity,
  setSnackMessage,
  fetchAll,
  setSnackOpen,
}) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const startOfYear = moment().startOf("year");

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const [checked, setChecked] = React.useState(false);
  const [timeValue, setTimeValue] = React.useState();

  const uploadExcel = async (e, discountMonth) => {
    try {
      const extractData = await extractEmployeeDiscount(e, discountMonth);
      await createEmployeeDiscount(extractData);
      setSnackSeverity("success");
      setSnackMessage("上載成功");
      fetchAll();
    } catch (error) {
      setSnackSeverity("error");
      if (error === "discount_not_match") {
        setSnackMessage(`上載失敗\n請上載正確EXCEL`);
      } else {
        setSnackMessage(`上載失敗 \n ${error}`);
      }
    }

    setSnackOpen(true);
    e.target.value = null;
  };

  return (
    <>
      <IconButton
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
      >
        <DriveFolderUploadIcon />
      </IconButton>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <Stack direction={"row"} spacing={2}>
          <FormControl>
            <DateTimePicker
              inputFormat="MM/YYYY"
              disablePast
              minDate={startOfYear.format("YYYY-MM-DD")}
              maxDate={startOfYear.add(12, "month").format("YYYY-MM-DD")}
              value={timeValue}
              renderInput={(props) => <TextField {...props} />}
              label="Month"
              openTo="month"
              views={["year", "month"]}
              onChange={(event) => {
                setTimeValue(event);
              }}
            />
          </FormControl>
          <IconButton component="label">
            <DriveFolderUploadIcon />
            <input
              hidden
              type={"file"}
              id={"csvFileInput"}
              accept={".xlsx"}
              onChange={(e) => {
                uploadExcel(e, moment(timeValue).format("YYYY-MM"));
                setChecked(false);
                setTimeValue();
                handleClose();
              }}
            />
          </IconButton>
        </Stack>
      </Menu>
    </>
  );
}

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const GroupHeader = styled("div")(({ theme }) => ({
  position: "sticky",
  top: "-8px",
  padding: "4px 10px",
  color: theme.palette.success.main,
  backgroundColor: lighten(theme.palette.success.light, 0.85),
  ...theme.applyStyles("dark", {
    backgroundColor: darken(theme.palette.success.main, 0.8),
  }),
}));

const GroupItems = styled("ul")({
  padding: 0,
});

function floatFixed2(num) {
  const value = isNaN(num)
    ? ""
    : num.split(".")[1]?.length > 2
    ? num.split(".")[0] + "." + num.split(".")[1].slice(0, 2)
    : num;
  const value2 = Math.sign(value) === -1 ? value * -1 : value;
  return value2;
}
